import React from 'react'

const FactsCounter = () => {
  return (
    <div className="container-fluid counter py-5">
        <div className="container py-5">
            <div className="row g-5">
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="counter-item">
                        <div className="counter-item-icon mx-auto">
                            <i className="fa-solid fa-arrows-down-to-people fa-3x text-white"></i>
                        </div>
                        <h4 className="text-white my-4">Individuals Engaged Across Over 5 Regions </h4>
                        <div className="counter-counting">
                            <span className="text-white fs-2 fw-bold" data-toggle="counter-up">1,073,520</span>
                            <span className="h1 fw-bold text-white">+</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.4s">
                    <div className="counter-item">
                        <div className="counter-item-icon mx-auto">
                            <i className="fa-solid fa-handshake-angle fa-3x text-white"></i>
                        </div>
                        <h4 className="text-white my-4">Volunteers</h4>
                        <div className="counter-counting">
                            <span className="text-white fs-2 fw-bold" data-toggle="counter-up">355</span>
                            <span className="h1 fw-bold text-white">+</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.6s">
                    <div className="counter-item">
                        <div className="counter-item-icon mx-auto">
                            <i className="fas fa-users fa-3x text-white"></i>
                        </div>
                        <h4 className="text-white my-4">Community Based Organizations</h4>
                        <div className="counter-counting">
                            <span className="text-white fs-2 fw-bold" data-toggle="counter-up">300</span>
                            <span className="h1 fw-bold text-white">+</span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.8s">
                    <div className="counter-item">
                        <div className="counter-item-icon mx-auto">
                            <i className="fa-solid fa-crown fa-3x text-white"></i>
                        </div>
                        <h4 className="text-white my-4">Local Authorities Engaged</h4>
                        <div className="counter-counting">
                            <span className="text-white fs-2 fw-bold" data-toggle="counter-up">448</span>
                            <span className="h1 fw-bold text-white">+</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

  )
}

export default FactsCounter